import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import "../../../src/styles/NotificationNavBarLayout.css";

// const NoriceCard = () => (
//   <Carousel className="noticecard" autoplay>
//     <div>
//       <h3 className="contentStyle">1</h3>
//     </div>
//     <div>
//       <h3 className="contentStyle">2</h3>
//     </div>
//     <div>
//       <h3 className="contentStyle">3</h3>
//     </div>
//     <div>
//       <h3 className="contentStyle">4</h3>
//     </div>
//   </Carousel>
// );
// export default NoriceCard;

const NoticeCard = () => {
    const base_url = process.env.REACT_APP_BASE_URL;

    const [noticeTitles, setNoticeTitles] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNoticeTitles = async () => {
            try {
                const accessToken = sessionStorage.getItem("accessToken");
                const user_id = sessionStorage.getItem("userData");
                const response = await axios.get(
                    `${base_url}/api/v1/client/notice/list`,
                    {
                        headers: {Authorization: `Bearer ${accessToken}`},
                    }
                );
                const {data} = response;
                // console.log(data);

                const updatedNotices = data.data.map((notice) => {
                    //const isClicked = clickedNotices.some((clickedNotice) => clickedNotice.notice_id === notice.notice_id);
                    return {
                        ...notice,
                    };
                });
                setNoticeTitles(updatedNotices);
                // console.log(updatedNotices);
                //   if (Array.isArray(data)) {
                //     const titles = data.map(notice => notice.notice_title); // Extract titles
                //     setNoticeTitles(updatedNotices); // Set the titles in the state
                //   } else {
                //     console.error('API did not return an array of notices');
                //   }
            } catch (error) {
                // Handle errors
                console.error(error);
            }
        };

        fetchNoticeTitles();
    }, []);

    const noticeList = () => {
        navigate("/notification-list");
      }

    return (
        <>
            <div className="noticecard">
                {noticeTitles.length > 0 ? (
                    <>
                    <div title="Click to see all Notices" className="contentStyle" onClick={noticeList}>{`${noticeTitles[0].notice_title} - ${noticeTitles[0].notice_content}`}</div>
                    </>
                ) : (<></>)
                }
            </div>
        </>
    );
};

export default NoticeCard;